export const phoneNumber = "1-540-700-7730"
export const textNumber = "15405509915"
export const emailAccount = "staffordlocksmith@gmail.com"
